import {
  Card,
  CardActionArea,
  CardContent,
  Typography
} from "@mui/material";
import { FC } from "react";

interface MiDaySettingToggleOptionCardProps {
  label: string;
  description: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
}

export const MiDaySettingToggleOptionCard: FC<MiDaySettingToggleOptionCardProps> = ({
  label,
  description,
  isSelected = false,
  isDisabled = false,
  onClick,
}) => (
  <Card
    elevation={0}
    sx={{
      borderRadius: 2,
      border: "1px solid",
      borderColor: isSelected ? "primary.main" : "grey.300",
      backgroundColor: isSelected ? "primary.light" : "grey.light",
      transition: "all 0.2s ease",
      ...(!isDisabled && {
        "&:hover": {
          borderColor: "primary.main",
          backgroundColor: "primary.light",
        },
      }),
    }}
  >
    <CardActionArea
      disableRipple={isDisabled}
      disableTouchRipple={isDisabled}
      onClick={isDisabled ? undefined : onClick}
      sx={{
        p: 0,
        m: 0,
        height: "100%",
        alignItems: "stretch",
        ...(isDisabled && {
          cursor: "default",
          "& .MuiCardActionArea-focusHighlight": {
            opacity: 0,
          },
          "&:hover .MuiCardActionArea-focusHighlight": {
            opacity: 0,
          },
        }),
      }}
    >
      <CardContent sx={{ p: 2, textAlign: "center" }}>
        <Typography
          sx={(theme) => ({
            fontSize: theme.fontSize.large,
            fontWeight: theme.fontWeight.semiBold,
          })}
          gutterBottom
        >
          {label}
        </Typography>

        <Typography
          sx={(theme) => ({
            fontSize: theme.fontSize.small,
            color: theme.palette.grey.medium,
          })}
        >
          {description}
        </Typography>
      </CardContent>
    </CardActionArea>
  </Card>
);
